var cov_18cdbvcb6i = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Checkbox/styles/index.ts",
      hash = "b364768b92c7515e948538dac208d8eb711e189c",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Checkbox/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 31
        },
        end: {
          line: 5,
          column: 71
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var checkinputLess = {};
import genaration from '../../utils/classname';
export var checkinputClass = (cov_18cdbvcb6i.s[0]++, genaration(checkinputLess, 'checkinput'));